import twittercard from 'modules/twittercard';
import opengraph from 'modules/opengraph';
import classes from 'component-classes';
import empty from 'modules/npm-component/empty';
import title from 'modules/title';
import metas from 'modules/metas';
import type from 'component-type';
import bus from 'modules/npm-component/bus';
import o from 'component-query';
import renderHeader from 'modules/header';
import renderFooter from 'modules/footer';
import { checkThemeFromHTMLClass } from 'modules/header/Header';

export default class Section {
  /**
   * Section constructor, classes are changed on the body
   * but the container is the specified to be rendering
   * the current view
   *
   * @param {Object} options
   * @api public
   */
  constructor(options) {
    this.container = o(options.container || 'body');
    this.classes = classes(o('html'));

    this.setMetadata = this.setMetadata.bind(this);
    this.append = this.append.bind(this);
    this.pagechange = this.pagechange.bind(this);
  }

  /**
   * Render section
   *
   * @param {Element|View} view
   * @param {Object} metadata
   * @api public
   */
  render({ view, metadata, append, footerTheme }) {
    bus.emit('page:change');

    this.setMetadata(metadata);

    renderHeader({ theme: checkThemeFromHTMLClass() });
    renderFooter({ theme: footerTheme });

    if (view) {
      if (!append) empty(this.container);

      const parsedView = type(view) !== 'array' ? [view] : view;
      parsedView.forEach(this.append, this);
    }

    // toggle loading flag by removing html's class
    this.classes.remove('auth0-website-loading');

    bus.emit('page:render');
  }

  setMetadata(metadata) {
    // set body classes
    (metadata.classes || []).forEach(this.classes.add, this.classes);

    // set page title
    if (type(metadata.title) === 'array') {
      title.apply(title, metadata.title);
    } else {
      title(metadata.title);
    }

    // set page meta tags
    metas(metadata.metas || {});
    opengraph(metadata.opengraph || {});
    twittercard(metadata.twittercard || {});

    this.pagechange(metadata);
  }

  /**
   * Append `view.el` or `view` element to
   * `Section.container`
   *
   * @param {Element|View} view
   * @api private
   */
  append(view) {
    this.container.appendChild(view.el || view);
  }

  /**
   * Register a pagechange event, to erease custom
   * page settings when page is left and before
   * the next one renders
   *
   * @param {Object} opts
   * @api private
   */
  pagechange(metadata) {
    bus.once('page:change', onpagechange.bind(this));

    function onpagechange() {
      // unset body classes to defaults
      (metadata.classes || []).forEach(this.classes.remove, this.classes);

      // unset page title to defaults
      title();

      // unset page metas to defaults
      metas({});
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/section-content/section.js